import { createSignal } from "solid-js";

const [isFooterVisible, setIsFooterVisible] = createSignal(true);

export const uiStore = {
  isFooterVisible,
};

export const uiActions = {
  setIsFooterVisible,
};
